import { useContext, useEffect, useState } from 'react'

import { DomainSupplyChainDTO } from 'features/globalSetup/api/types/domainSupplyChainDTO'
import { SupplyChainContext } from 'features/globalSetup/contexts/SupplyChainContext'
import { DomainSupplyChain } from 'features/globalSetup/types/domainSupplyChain'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO, sortToDTO } from './api/mapper'
import { GET_DOMAIN_SUPPLY_CHAINS } from './api/query'
import { Data, Variables } from './api/types'
import { Props, UseGetDomainSupplyChains } from './types'

export const useGetDomainSupplyChains = ({
  filters,
  first,
  last,
  sort,
  supplyChainId,
}: Props): UseGetDomainSupplyChains => {
  const [domainSupplyChains, setDomainSupplyChains] = useState<DomainSupplyChain[]>([])
  const [count, setCount] = useState<number>(0)
  const { setLoading } = useContext(SupplyChainContext)

  const { isLoading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data): Promise<void> => {
      const {
        domainSupplyChains: { nodes: domainSupplyChains, totalCount: count },
      } = data
      if (domainSupplyChains) {
        setDomainSupplyChains(
          domainSupplyChains.map(
            (domainSupplyChain: DomainSupplyChainDTO): DomainSupplyChain =>
              fromDTO(domainSupplyChain),
          ),
        )
        setCount(count)
      }
    },
    query: GET_DOMAIN_SUPPLY_CHAINS,
    variables: {
      first,
      last,
      sort: sortToDTO(sort),
      supplyChainId,
      terms: filters,
    },
  })

  useEffect(() => {
    setLoading(isLoading)
  }, [isLoading])

  return {
    count,
    domainSupplyChains,
  }
}
